import React, { useEffect, useState } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate } from "react-router-dom";
import config from "../../config";

function Dashboard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState("");
  useEffect(() => {
    const token = sessionStorage.getItem("tokenclassix");
    const schoolCode = sessionStorage.getItem("schoolCode");

    if (!token) {
      navigate("/");
      return;
    }

    fetch(`${config.API_BASE_URL}/PrincipalDashBoardCount_CL9`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      // body: JSON.stringify({ schooL_CODE: schoolCode }),
    })
      .then((response) => {
        if (!response.ok) {
          setLoading(false);
          throw new Error("Failed to fetch dashboard data");
        }
        return response.json();
      })
      .then((data) => {
        setLoading(false);
        console.log("Dashboard data:", data);
        setCount(data.data.dashboardCount_list);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error:", error);
      });
  }, [navigate]);

  return (
    <>
      <div class="container-scroller">
        <Navbar />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div class="container-fluid page-body-wrapper">
          <Sidebar />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <div class="row">
                    <div class="col-12 col-xl-12 mb-4 mb-xl-0">
                      <h3
                        class="font-weight-bold"
                        style={{ textTransform: "uppercase" }}
                      >
                        Welcome Principal
                      </h3>
                      <h6
                        class="font-weight-normal mb-2"
                        style={{ textTransform: "uppercase" }}
                      >
                        School Code: {sessionStorage.getItem("schoolCode")}
                      </h6>
                      <h6 class="font-weight-normal mb-0">
                        {sessionStorage.getItem("schoolname")?.toUpperCase()}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <>
                  <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                    <div className="card card-tale">
                      <a
                        href="#"
                        className="card-body"
                        style={{ textDecoration: "none" }}
                      >
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="mb-2">
                              Admission <br />
                              Register
                            </h3>
                            <p className="fs-30 mb-2 mt-4">
                              {count.admissioN_COUNT || "0"}
                            </p>
                          </div>
                          <div className="col-md-4 text-center">
                            <i
                              className="fa fa-users icon-large"
                              style={{ fontSize: 40 }}
                            ></i>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-total-registration");
                      }}
                      className="card card-success"
                      style={{ textDecoration: "none" }}
                    >
                      <div className="card-body">
                        <div className="row">
                          <div
                            className="col-md-5"
                            style={{ borderRight: "1px solid #FFFFFF" }}
                          >
                            <h3 className="mb-2">
                              Total <br />
                              Count
                            </h3>
                            <p className="fs-30 mb-2 mt-4">
                              {count.totaL_APPLICANTS || "0"}
                            </p>
                          </div>
                          <div className="col-md-7" style={{ fontWeight: 600 }}>
                            <p className="fs-10 mb-2 mt-1">
                              Private: {count.private || "0"}
                            </p>
                            <p className="fs-10 mb-2 mt-1">
                              Regular: {count.regular || "0"}
                            </p>
                            <p className="fs-10 mb-2 mt-1">
                              Ex-regular: {count.eX_REGULAR || "0"} /{" "}
                              {count.totaL_EX_REGULAR_STU || "0"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <span
                          className="small-box-footer"
                          style={{ textDecoration: "none" }}
                        >
                          Print Checklist
                        </span>
                      </div>
                    </a>
                  </div>

                  <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-checklist-generated");
                      }}
                      className="card card-dark-blue"
                      style={{ textDecoration: "none" }}
                    >
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="mb-2">
                              Checklist <br />
                              Generated
                            </h3>
                            <p className="fs-30 mb-2 mt-4">
                              {count.checklisT_GENERATED || "0"}
                            </p>
                          </div>
                          <div class="col-md-4" style={{ textAlign: "center" }}>
                            <i
                              class="fa fa-list icon-large"
                              style={{ fontSize: "40px" }}
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div>
                        <span
                          className="small-box-footer"
                          style={{ textDecoration: "none" }}
                        >
                          Submit to DEO
                        </span>
                      </div>
                    </a>
                  </div>

                  <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-deo-pending");
                      }}
                      className="card card-light-danger"
                      style={{ textDecoration: "none" }}
                    >
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="mb-2">
                              Pending <br />
                              at deo
                            </h3>
                            <p className="fs-30 mb-2 mt-4">
                              {count.deO_PENDING || "0"}
                            </p>
                          </div>
                          <div class="col-md-4" style={{ textAlign: "center" }}>
                            <i
                              class="fa fa-list-ol icon-large"
                              style={{ fontSize: "40px" }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-deo-approve");
                      }}
                      className="card card-light-warning"
                      style={{ textDecoration: "none" }}
                    >
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="mb-2">
                              DEO <br />
                              Approved
                            </h3>
                            <p className="fs-30 mb-2 mt-4">
                              {count.deO_APPROVED || "0"}
                            </p>
                          </div>
                          <div class="col-md-4" style={{ textAlign: "center" }}>
                            <i
                              class="fa fa-check-square-o icon-large"
                              style={{ fontSize: "40px" }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-deo-reject");
                      }}
                      className="card card-light-grey"
                      style={{ textDecoration: "none" }}
                    >
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="mb-2">
                              DEO <br />
                              Rejected
                            </h3>
                            <p className="fs-30 mb-2 mt-4">
                              {count.deO_REJECTED || "0"}
                            </p>
                          </div>
                          <div class="col-md-4" style={{ textAlign: "center" }}>
                            <i
                              class="fa fa-user-times icon-large"
                              style={{ fontSize: "40px" }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-generate-challan");
                      }}
                      className="card card-orange"
                      style={{ textDecoration: "none" }}
                    >
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="mb-2">
                              Generate
                              <br />
                              Challan
                            </h3>
                            <p className="fs-30 mb-2 mt-4">
                              {count.challaN_GENERATE_PENDING || "0"}
                            </p>
                          </div>
                          <div class="col-md-4" style={{ textAlign: "center" }}>
                            <i
                              class="fa fa-clock-o  icon-large"
                              style={{ fontSize: "40px" }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-challan-status");
                      }}
                      className="card card-dark-danger"
                      style={{ textDecoration: "none" }}
                    >
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="mb-2">
                              Challan <br />
                              Status
                            </h3>
                            <p className="fs-30 mb-2 mt-4">
                              {count.generateD_CHALLAN_STATUS || "0"}
                            </p>
                          </div>
                          <div class="col-md-4" style={{ textAlign: "center" }}>
                            <i
                              class="fa fa-clipboard  icon-large"
                              style={{ fontSize: "40px" }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-consolidated-checklist");
                      }}
                      className="card card-tale"
                      style={{ textDecoration: "none" }}
                    >
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="mb-2">
                              List of
                              <br />
                              Registered Students
                            </h3>
                            <p className="fs-30 mb-2 mt-4">
                              {count.consolidateD_STATEMENT || "0"}
                            </p>
                          </div>
                          <div class="col-md-4" style={{ textAlign: "center" }}>
                            <i
                              class="fa fa-download icon-large"
                              style={{ fontSize: "40px" }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-3 col-xl-3 mb-4 stretch-card transparent">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                      className="card card-light-danger"
                      style={{ textDecoration: "none" }}
                    >
                      <div className="card-body">
                        <div className="row">
                          <div
                            className="col-md-6"
                            style={{ borderRight: "1px solid #FFFFFF" }}
                          >
                            <h3 className="mb-2">
                              Challan <br />
                              Limit
                            </h3>
                            <p className="fs-30 mb-2 mt-4">
                              {count.challaN_LIMIT || "0"}
                            </p>
                          </div>
                          <div className="col-md-6" style={{ fontWeight: 600 }}>
                            <h3 className="mb-2">
                              Challan <br />
                              Left
                            </h3>
                            <p className="fs-30 mb-2 mt-4">
                              {count.challaN_LEFT || "0"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
